import React from 'react'

import './DataProtection.css'

const DataProtection = ({ text }) => (
    <div className="data-protection" dangerouslySetInnerHTML={{ __html: text }} />
)

export { DataProtection }
